import { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import {
  CreateDrdMemberFormTypes,
  CreateDrdMemberFormSubmitValuesTypes,
  CreateDrdMemberFormSubmitActionsTypes,
} from 'types/member'
import useMemberStore from 'store/member'

const CREATEDRDMEMBERTXINITVAL: CreateDrdMemberFormTypes = {
  firstName: null,
  lastName: null,
  address1: null,
  address2: null,
  address3: null,
  address4: null,
  suburb: null,
  city: null,
  state: null,
  postCode: null,
  countryId: null,
  physicalAddress1: null,
  physicalAddress2: null,
  physicalAddress3: null,
  physicalAddress4: null,
  physicalSuburb: null,
  physicalCity: null,
  physicalState: null,
  physicalPostCode: null,
  physicalCountryId: null,
  custom1: null,
  custom2: null,
  custom3: null,
  comments: null,
  ident: null,
}

export const useCreateDrdMember = (
  onCloseModal: () => void
): {
  isLoading: boolean
  initialValues: CreateDrdMemberFormTypes
  handleSubmitCreateDrdMember: (
    values: CreateDrdMemberFormSubmitValuesTypes,
    actions: CreateDrdMemberFormSubmitActionsTypes
  ) => void
} => {
  const navigate = useNavigate()
  // MEMBER CREATE START
  const drdMemberTraderIdNewlyCreated = useMemberStore(
    (state) => state.drdMemberTraderIdNewlyCreated
  )
  const createDrdMember = useMemberStore((state) => state.createDrdMember)
  const drdMemberCreateLoading = useMemberStore(
    (state) => state.drdMemberCreateLoading
  )
  // MEMBER CREATE END

  // MISC STATES START
  const [initialValues] = useState<CreateDrdMemberFormTypes>({
    ...CREATEDRDMEMBERTXINITVAL,
  })
  // MISC STATES END

  const isLoading = useMemo(() => {
    return drdMemberCreateLoading ? true : false
  }, [drdMemberCreateLoading])

  useEffect(() => {
    if (drdMemberTraderIdNewlyCreated)
      navigate(`/member-profile/${drdMemberTraderIdNewlyCreated}`)
  }, [drdMemberTraderIdNewlyCreated])

  const handleSubmitCreateDrdMember = useCallback(
    async (
      values: CreateDrdMemberFormSubmitValuesTypes,
      actions: CreateDrdMemberFormSubmitActionsTypes
    ) => {
      try {
        actions.setSubmitting(true)
        const result = await createDrdMember(values)
        console.log({ result })
        toast.success(`Create DRD Member successful.`)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      } finally {
        actions.setSubmitting(false)
      }
    },
    [createDrdMember]
  )

  return {
    isLoading,
    initialValues,
    handleSubmitCreateDrdMember,
  }
}
